import React from 'react';
import { ReviewQueueStatus } from 'api/DataReview';
import Status from 'Components/DesignSystem/Status/Status';
import { StatusTone } from 'types/DesignSystem/Status';

interface Props {
  status: ReviewQueueStatus;
}

/**
 * The queue status chip, on the DS `Status` (2026-09-05). It was a hand-rolled
 * pill on raw `orange-100` / `green-100` / `red-100` fills — light-only literals
 * the dark theme could not reach — plus the `grey-200`-ground Pending case whose
 * border had to be hand-picked to stay visible (the § 178 chip-grounds note).
 * The tone system owns all four of those decisions now.
 */
const STATUS_TONE: Record<ReviewQueueStatus, StatusTone> = {
  Pending: 'neutral',
  'In Progress': 'warning',
  Completed: 'success',
  Failed: 'danger',
};

const ReviewQueueStatusPill: React.FC<Props> = ({ status }) => (
  <Status tone={STATUS_TONE[status] || 'neutral'} label={status} data-testid={`review-queue-status-${status.replace(/\s+/g, '-').toLowerCase()}`} />
);

export default ReviewQueueStatusPill;
